import { getRoot } from './getters';
export const isContentEmpty = (content) => {
    return getRoot(content).value.sections.length === 0;
};
